module.exports = __webpack_public_path__ + "static/media/S1N4-6.5a237df2.svg";